export default __webpack_public_path__ + "static/mobile_dock_m-7e4a6e85cc5ddeed0552414ff11487d3.png";